import React from 'react';
import get from 'lodash/get';
import {Link} from 'react-router-dom';
import {FormattedMessage} from 'react-intl';
import {shape, arrayOf, string, func} from 'prop-types';

const PrizeBreakId = props => {
  const challengeIds = get(props.prize, 'challengeIds', []);

  if (challengeIds.length === 1) {
    const content = get(props.prize, 'challengePermalinks[0]', challengeIds[0]);

    return (
      <Link to={`/break/${challengeIds[0]}/edit`}>
        {content}
      </Link>
    );
  } else if (challengeIds.length > 1) {
    const handleClick = event => {
      event.preventDefault();
      props.onClick(props.prize.id);
    };

    return (
      <Link to='#' onClick={handleClick}>
        <FormattedMessage id='prizeList.column.content.breakId.multiple' />
      </Link>
    );
  } else {
    return null;
  }
};

PrizeBreakId.propTypes = {
  prize: shape({
    challengePermalinks: arrayOf(string),
    challengeIds: arrayOf(string)
  }),
  onClick: func.isRequired
};

export default PrizeBreakId;



// WEBPACK FOOTER //
// ./public/components/prizes/PrizeBreakId.jsx